import { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { useLang } from '../../i18n';

const Parola = ({ text, progress, start, end }) => {
  const opacity = useTransform(progress, [start, end], [0.16, 1]);
  const y = useTransform(progress, [start, end], [10, 0]);
  return (
    <motion.span
      style={{ opacity, y }}
      className="mr-[0.28em] inline-block"
    >
      {text}
    </motion.span>
  );
};

/**
 * Le tre righe del manifesto che si accendono parola per parola mentre scorri.
 *
 * Era una sezione a sé, col suo kicker «Il nostro modo di apparecchiare»: che è
 * esattamente ciò di cui parlava la sezione successiva, il metodo. Ora è
 * l'apertura di quella — il credo, e subito sotto come si mette in pratica —
 * quindi qui resta solo il paragrafo, senza cornice né intestazione proprie.
 */
export const ManifestoWords = () => {
  const { t } = useLang();
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ['start 0.9', 'end 0.55'],
    layoutEffect: false,
  });
  const lines = [t('home.manifesto1'), t('home.manifesto2'), t('home.manifesto3')];
  const words = lines.flatMap((line) => line.split(' ').map((w) => ({ w })));
  const total = words.length;

  return (
    <p
      ref={ref}
      data-testid="home-manifesto"
      className="max-w-[32ch] font-display text-[24px] leading-snug md:text-[32px] lg:text-[36px]"
    >
      {/* Le parole sono span separati: senza la frase intera lo screen reader le legge attaccate. */}
      <span className="sr-only">{lines.join(' ')}</span>
      <span aria-hidden="true">
      {words.map((item, i) => (
        <Parola
          key={`${item.w}-${i}`}
          text={item.w}
          progress={scrollYProgress}
          start={Math.max(0, i / total - 0.06)}
          end={Math.min(1, i / total + 0.12)}
        />
      ))}
      </span>
    </p>
  );
};
